import { TableCell } from '@mui/material'
import React from 'react'
import MyTable from '../../UI/table/MyTable'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import PackBoxItem from './PackBoxItem'

const PackBoxesTable = ({ packId, boxes, count, offset, setOffset, limit, setLimit }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Коробка</TableCell>
                <TableCell align="right">Дії</TableCell>
            </>
        }
        body={
            boxes && boxes.length > 0 ?
                boxes.map(box => 
                    <PackBoxItem
                        key={box.id}
                        packId={packId}
                        box={box} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Коробок не знайдено' 
                    columns={6}
                />
        }
        name='коробок'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
    />
  )
}

export default PackBoxesTable